import React from 'react';
import { Box, Spinner } from '@chakra-ui/react';

const Loading = () => {
    return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
            <Spinner size="xl" />
        </Box>
    );
};

export default Loading;
